import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SsoLoginComponent } from './sso-login/sso-login.component';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import {FormsModule, NgModel, ReactiveFormsModule} from '@angular/forms';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NZ_ICONS, NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { CommonModule } from '@angular/common';

import {
  EyeInvisibleOutline,
  EyeOutline,
  KeyOutline,
  LogoutOutline,
  SettingOutline,
  BgColorsOutline,
  TeamOutline,
  BulbOutline,
  CheckCircleOutline,
  AppstoreOutline,
  MenuOutline,
  SearchOutline,
  QuestionCircleOutline,
  HomeOutline,
  UserOutline,
  SafetyOutline,
  MobileOutline,
  FileTextOutline,
  PhoneOutline,
  PlusOutline,
  RightOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  DownOutline,
  UpOutline,
  HistoryOutline,
  DatabaseOutline,
  BellOutline,
  BellFill,
  SoundFill,
  NotificationOutline,
  CustomerServiceOutline,
  EnvironmentOutline,
  PaperClipOutline,
  ClockCircleOutline,
  
} from '@ant-design/icons-angular/icons';
import { AuthCallbackComponent } from './sso-login/auth-callback.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardSidebarComponent } from './dashboard/components/dashboard-sidebar/dashboard-sidebar.component';
import { DashboardTopbarComponent } from './dashboard/components/dashboard-topbar/dashboard-topbar.component';
import { WelcomeBannerComponent } from './dashboard/components/welcome-banner/welcome-banner.component';
import { QuickAccessGridComponent } from './dashboard/components/quick-access-grid/quick-access-grid.component';
import { SupportContactPanelComponent } from './dashboard/components/support-contact-panel/support-contact-panel.component';
import { AllSystemsSectionComponent } from './dashboard/components/all-systems-section/all-systems-section.component';
import { NotificationsSlideComponent } from './dashboard/components/notifications-slide/notifications-slide.component';
import { NotificationsDropdownComponent } from './dashboard/components/notifications-dropdown/notifications-dropdown.component';
import { NotificationUiModule } from '../shared/notification-ui/notification-ui.module';
import { FeatureRoutingModule } from './feature-routing.module';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import {AuthLogoutComponent} from "./sso-login/auth-logout.component";
import { NzModalModule } from 'ng-zorro-antd/modal';
import {ChangePasswordComponent} from "@app/modules/change-password/change-password.component";
import {ForgotPasswordComponent} from "@app/modules/forgot-password/forgot-password.component";
import {Verify2faComponent} from "@app/modules/verify-2fa/verify-2fa.component";
import {Setup2faComponent} from "@app/modules/setup-2fa/setup-2fa.component";
import {RecoveryRequestComponent} from "@app/modules/recovery-request/recovery-request.component";
import { ConfirmContactComponent } from "@app/modules/confirm-contact/confirm-contact.component";
import { ProfileComponent } from "@app/modules/profile/profile.component";
import { SsoDiagramComponent } from './dashboard/components/sso-diagram/sso-diagram.component';
import { SsoUserGuideComponent } from './dashboard/components/sso-user-guide/sso-user-guide.component';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FeatureRoutingModule,
    SharedModule,
    TranslateModule,
    ReactiveFormsModule,
    NzGridModule,
    NzIconModule,
    NzButtonModule,
    NzLayoutModule,
    NzCardModule,
    NzToolTipModule,
    NzDropDownModule,
    NzMenuModule,
    NzPopoverModule,
    CommonModule,
    NzMessageModule,
    NzModalModule,
    NzSpinModule,
    NzCarouselModule,
    FormsModule,
    NotificationUiModule,
   
  ],
  declarations: [
    SsoLoginComponent,
    AuthCallbackComponent,
    DashboardComponent,
    DashboardSidebarComponent,
    DashboardTopbarComponent,
    WelcomeBannerComponent,
    QuickAccessGridComponent,
    SupportContactPanelComponent,
    AllSystemsSectionComponent,
    NotificationsSlideComponent,
    NotificationsDropdownComponent,
    UnauthorizedComponent,
    AuthLogoutComponent,
    ChangePasswordComponent,
    ForgotPasswordComponent,

    Verify2faComponent,
    Setup2faComponent,
    RecoveryRequestComponent,

    ConfirmContactComponent,
    ProfileComponent,
    SsoDiagramComponent,
    SsoUserGuideComponent
  ],
  schemas: [NO_ERRORS_SCHEMA],
  providers: [
    {
      provide: NZ_ICONS,
      useValue: [
        EyeOutline,
        EyeInvisibleOutline,
        SettingOutline,
        LogoutOutline,
        KeyOutline,
        BgColorsOutline,
        TeamOutline,
        BulbOutline,
        CheckCircleOutline,
        AppstoreOutline,
        MenuOutline,
        SearchOutline,
        QuestionCircleOutline,
        HomeOutline,
        UserOutline,
        SafetyOutline,
        MobileOutline,
        FileTextOutline,
        PhoneOutline,
        PlusOutline,
        RightOutline,
        MenuFoldOutline,
        MenuUnfoldOutline,
        DownOutline,
        UpOutline,
        HistoryOutline,
        DatabaseOutline,
        BellOutline,
        BellFill,
        SoundFill,
        NotificationOutline,
        CustomerServiceOutline,
        EnvironmentOutline,
        PaperClipOutline,
        ClockCircleOutline,
      ],
    },
  ]
})
export class FeatureModule {}
